<template>
  <TabPanels>
    <TabPanel>
      <div>
        <p class="text-blueSecondry font-bold mb-1 pl-5">所属議会</p>
        <p class="text-blueSecondry mb-4 pl-5">
          {{ cityCouncil }}
        </p>
      </div>
      <div>
        <p class="text-blueSecondry font-bold mb-1 pl-5">所属会派</p>
        <p class="text-blueSecondry mb-4 pl-5">
          {{ currentUser.denomination_name }}
        </p>
      </div>
      <div>
        <p class="text-blueSecondry font-bold mb-1 pl-5">氏名</p>
        <p class="text-blueSecondry mb-4 pl-5">{{ currentUser.name }}</p>
      </div>
      <div>
        <p class="text-blueSecondry font-bold mb-1 pl-5">
          議員ID［メールアドレス］
        </p>
        <p class="text-blueSecondry mb-4 pl-5">{{ currentUser.email }}</p>
      </div>
      <p class="text-blueSecondry pl-5 mt-8">
        ※上記は事務局入力データのため、修正は事務局までお問い合わせください
      </p>
    </TabPanel>
    <TabPanel> </TabPanel>
    <TabPanel>
      <p class="text-blueSecondry font-bold mb-4 pl-5">パスワード設定</p>
      <div class="relative w-full pl-5 pr-5 mb-2">
        <div class="absolute inset-y-0 right-0 flex items-center pr-8">
          <font-awesome-icon
            :icon="passwordInputType1 == 'text' ? 'eye' : 'eye-slash'"
            @click="togglePasswordInputType1"
            :style="{ color: '#4F82E6' }"
          />
        </div>
        <input
          placeholder="現在のパスワードを入力ください"
          class="h-10 border appearance-none border-blueSecondary rounded-full w-full px-5 leading-tight focus:outline-none"
          :class="passwordError ? 'bg-blueSecondry bg-opacity-25' : ''"
          id="nowpassword"
          name="nowpassword"
          autocomplete="off"
          :type="passwordInputType1"
          :value="oldPass"
          @input="$emit('update:oldPass', $event.target.value)"
        />
      </div>
      <div class="relative w-full pl-5 pr-5 mb-2">
        <div class="absolute inset-y-0 right-0 flex items-center pr-8">
          <font-awesome-icon
            :icon="passwordInputType2 == 'text' ? 'eye' : 'eye-slash'"
            @click="togglePasswordInputType2"
            :style="{ color: '#4F82E6' }"
          />
        </div>
        <input
          placeholder="新しいパスワードを入力ください［半角英数6文字以上]"
          class="h-10 border appearance-none border-blueSecondary rounded-full w-full px-5 leading-tight focus:outline-none"
          :class="passwordError ? 'bg-blueSecondry bg-opacity-25' : ''"
          id="newpassword1"
          name="newpassword1"
          autocomplete="off"
          :type="passwordInputType2"
          :value="newPass"
          @input="$emit('update:newPass', $event.target.value)"
        />
      </div>
      <div class="relative w-full pl-5 pr-5">
        <div class="absolute inset-y-0 right-0 flex items-center pr-8">
          <font-awesome-icon
            :icon="passwordInputType3 == 'text' ? 'eye' : 'eye-slash'"
            @click="togglePasswordInputType3"
            :style="{ color: '#4F82E6' }"
          />
        </div>
        <input
          placeholder="新しいパスワードをもう一度入力ください"
          class="h-10 border appearance-none border-blueSecondary rounded-full w-full px-5 leading-tight focus:outline-none"
          :class="passwordError ? 'bg-blueSecondry bg-opacity-25' : ''"
          id="newpassword2"
          name="newpassword2"
          autocomplete="off"
          :type="passwordInputType3"
          :value="confirmPass"
          @input="$emit('update:confirmPass', $event.target.value)"
        />
      </div>
    </TabPanel>
  </TabPanels>
</template>

<script>
import { useAuth } from '@/services/useAuth'
import { TabPanel, TabPanels } from '@headlessui/vue'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'ProfileForm',

  components: {
    TabPanel,
    TabPanels,
  },

  props: {
    oldPass: String,
    newPass: String,
    confirmPass: String,
  },

  emits: ['update:old', 'update:newpass', 'update:conf'],

  setup() {
    const { currentUser } = useCurrentUser()
    const cityCouncil = process.env.VUE_APP_CITY_COUNCIL
    return {
      currentUser,
      cityCouncil,
      ...useAuth(),
    }
  },
}
</script>
